// Telefon (krok 13.7, 05/989 „Telefon podporovat všude“; návrh docs/predani/2026-09-28-telefon-navrh.md § 4):
// jediný práh pro telefon na výšku je 560 px — stejné číslo je v CSS jako `@media (max-width: 560px)` a v tokenu
// `--telefon-prah` (shodu hlídá test/css-telefon.test.ts). Pod 950 px (`--lista-prah`) je menu vysouvací.
// Rozvržení řeší CSS; tady jen to, co se podle šířky okna vykresluje jinak (spodní lišta, sbalená lišta).
import { useEffect, useState } from 'react';

/** Telefon na výšku — spodní lišta, sekce od kraje ke kraji, dialogy přes celou výšku. */
export const DOTAZ_TELEFON = '(max-width: 560px)';

/** Menu jako vysouvací zásuvka místo lišty vlevo (tablet na výšku, telefon) — `--lista-prah` 950 px. */
export const DOTAZ_VYSOUVACI_MENU = '(max-width: 949px)';

/**
 * Spodní lišta (Domů · tři sekce · Menu): telefon na výšku a dotykový tablet na výšku pod 950 px — rozhodnutí zadavatele
 * 11. 10. 2026 (05/2940 a, W51). Stejné podmínky má Shell.css (telefonní blok a blok tabletu na výšku).
 */
export const DOTAZ_SPODNI_LISTA = '(max-width: 560px), (pointer: coarse) and (max-width: 949px)';

/**
 * Dotykový tablet na výšku se spodní lištou (561–949 px) — bez telefonu. Hlavička tu nemá ☰ (Menu je ve spodní liště)
 * a nápověda je v nabídce pod iniciálami (rozhodnutí zadavatele 30. 10. 2026 „Uklidit, Nahlásit nechat“, W86).
 * Stejný dotaz má Shell.css.
 */
export const DOTAZ_TABLET_SPODNI_LISTA =
  '(min-width: 561px) and (max-width: 949px) and (pointer: coarse)';

function plati(dotaz: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(dotaz).matches
    : false;
}

/**
 * Platí mediální dotaz? Sleduje změnu (otočení telefonu, zúžení okna). Bez `matchMedia` (jsdom v unit testech)
 * vrací false — aplikace se pak chová jako na počítači.
 */
export function useMediaDotaz(dotaz: string): boolean {
  const [shoda, setShoda] = useState(() => plati(dotaz));
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const seznam = window.matchMedia(dotaz);
    setShoda(seznam.matches);
    const naZmenu = (udalost: MediaQueryListEvent) => setShoda(udalost.matches);
    seznam.addEventListener('change', naZmenu);
    return () => seznam.removeEventListener('change', naZmenu);
  }, [dotaz]);
  return shoda;
}

/** Je okno telefon na výšku (≤ 560 px)? */
export function useJeTelefon(): boolean {
  return useMediaDotaz(DOTAZ_TELEFON);
}

/** Má okno spodní lištu (telefon, dotykový tablet na výšku)? */
export function useMaSpodniListu(): boolean {
  return useMediaDotaz(DOTAZ_SPODNI_LISTA);
}

/** Je okno dotykový tablet na výšku se spodní lištou (ne telefon)? */
export function useJeTabletSeSpodniListou(): boolean {
  return useMediaDotaz(DOTAZ_TABLET_SPODNI_LISTA);
}
